{
  "common": {
    "cancel": "Cancelar",
    "saveChanges": "Guardar cambios"
  },
  "createUser": {
    "title": "Registrar nuevo alumno",
    "namePlaceholder": "Nombre del alumno",
    "emailPlaceholder": "Correo del alumno",
    "accessGroupPlaceholder": "Grupo de acceso",
    "noActiveGroups": "Ningún grupo activo",
    "groupCourses_one": "({{count}} curso)",
    "groupCourses_zero": "({{count}} cursos)",
    "groupCourses_other": "({{count}} cursos)",
    "password": "Contraseña",
    "passwordMode": {
      "emailTitle": "Enviar enlace por correo",
      "emailSubtitle": "El alumno define su propia contraseña",
      "manualTitle": "Definir contraseña manualmente",
      "manualSubtitle": "Tú eliges la contraseña del alumno"
    },
    "passwordPlaceholder": "Mínimo 8 caracteres",
    "submit": "Registrar",
    "validation": {
      "nameMin": "El nombre debe tener al menos 2 caracteres",
      "emailInvalid": "Correo no válido",
      "passwordMin": "La contraseña debe tener al menos 8 caracteres"
    },
    "toast": {
      "createdEmailSent": "Miembro creado — correo para definir la contraseña enviado",
      "created": "¡Miembro creado correctamente!",
      "createError": "Error al crear el miembro."
    }
  },
  "roles": {
    "STUDENT": "Alumno",
    "INSTRUCTOR": "Instructor",
    "ADMIN": "Admin",
    "SUPER_ADMIN": "Super Admin",
    "AFFILIATE": "Afiliado"
  },
  "statuses": {
    "ACTIVE": "Activo",
    "INACTIVE": "Inactivo",
    "BLOCKED": "Bloqueado",
    "SUSPENDED": "Suspendido",
    "PENDING_VERIFICATION": "Pendiente"
  },
  "userEditDialog": {
    "title": "Editar usuario",
    "description": "Edita la información y los permisos del usuario",
    "personalData": "Datos personales",
    "name": "Nombre",
    "namePlaceholder": "Nombre completo",
    "email": "Correo electrónico",
    "emailPlaceholder": "correo@ejemplo.com",
    "permissions": "Permisos",
    "role": "Rol",
    "rolePlaceholder": "Selecciona el permiso",
    "status": "Estado",
    "statusPlaceholder": "Selecciona el estado",
    "updateError": "Error al actualizar el usuario",
    "validation": {
      "nameMin": "El nombre debe tener al menos 3 caracteres",
      "emailInvalid": "Correo no válido"
    }
  },
  "enrollUser": {
    "title": "Inscribir usuario",
    "description": "Añade un usuario al grupo \"{{group}}\"",
    "successTitle": "¡Inscripción realizada!",
    "successMessage": "{{name}} se inscribió correctamente.",
    "searchLabel": "Buscar usuario *",
    "change": "Cambiar",
    "searchPlaceholder": "Buscar por nombre, correo o CPF...",
    "search": "Buscar",
    "noUsersFound": "No se encontró ningún usuario",
    "expirationDate": "Fecha de caducidad",
    "optional": "(opcional)",
    "expirationHint": "Déjalo en blanco para usar la configuración del grupo",
    "group": "Grupo:",
    "productsIncluded_one": "{{count}} producto incluido",
    "productsIncluded_zero": "{{count}} productos incluidos",
    "productsIncluded_other": "{{count}} productos incluidos",
    "enrolling": "Inscribiendo...",
    "enroll": "Inscribir",
    "enrollError": "Error al inscribir al usuario",
    "validation": {
      "userRequired": "Selecciona un usuario"
    }
  },
  "time": {
    "never": "Nunca",
    "justNow": "Justo ahora",
    "minutesAgo": "hace {{minutes}} min",
    "hoursAgo": "hace {{hours}} h",
    "daysAgo": "hace {{days}} d"
  },
  "usersPage": {
    "title": "Miembros",
    "registeredCount_one": "{{count}} miembro registrado",
    "registeredCount_zero": "{{count}} miembros registrados",
    "registeredCount_other": "{{count}} miembros registrados",
    "searchPlaceholder": "Busca por nombre, correo o CPF",
    "createStudent": "Registrar alumno",
    "filters": {
      "title": "Filtros",
      "clearAll": "Borrar todo",
      "status": "Situación",
      "allStatuses": "Todas",
      "accessGroup": "Grupo de acceso",
      "allGroups": "Todos los grupos",
      "createdAt": "Fecha de registro",
      "from": "Desde",
      "to": "Hasta",
      "lastLogin": "Último acceso",
      "active": "Filtros activos:",
      "chip": {
        "status": "Situación: {{value}}",
        "group": "Grupo: {{value}}",
        "createdAt": "Registro: {{from}} → {{to}}",
        "lastLogin": "Último acceso: {{from}} → {{to}}"
      }
    },
    "export": {
      "tooltip": "Exportar miembros en CSV",
      "button": "Exportar",
      "generating": "Generando CSV...",
      "empty": "No hay miembros para exportar",
      "success_one": "CSV generado — {{count}} miembro",
      "success_zero": "CSV generado — {{count}} miembros",
      "success_other": "CSV generado — {{count}} miembros",
      "error": "Error al exportar",
      "fileName": "usuarios",
      "yes": "Sí",
      "no": "No",
      "headers": {
        "id": "ID",
        "name": "Nombre",
        "email": "Correo electrónico",
        "phone": "Teléfono",
        "cpf": "CPF",
        "role": "Rol",
        "status": "Estado",
        "emailVerified": "Correo verificado",
        "courses": "Cursos",
        "certificates": "Certificados",
        "lastLogin": "Último inicio de sesión",
        "createdAt": "Registrado el"
      }
    },
    "table": {
      "member": "Miembro",
      "role": "Rol",
      "status": "Estado",
      "courses": "Cursos",
      "certificates": "Certificados",
      "lastLogin": "Último acceso",
      "actions": "Acciones"
    },
    "actions": {
      "openMenu": "Abrir menú",
      "edit": "Editar miembro",
      "generateDeepLink": "Generar deep link",
      "sendPasswordReset": "Enviar correo para definir la contraseña",
      "deactivate": "Desactivar miembro",
      "activate": "Activar miembro"
    },
    "toast": {
      "activated": "Miembro activado",
      "deactivated": "Miembro desactivado",
      "statusError": "Error al cambiar el estado",
      "passwordResetSent": "Correo para definir la contraseña enviado a {{email}}",
      "emailError": "Error al enviar el correo",
      "deepLinkError": "Error al generar el deep link"
    },
    "pagination": {
      "showing": "Mostrando <bold>{{from}}</bold> – <bold>{{to}}</bold> de <bold>{{total}}</bold> miembros",
      "previous": "Anterior",
      "next": "Siguiente"
    },
    "empty": {
      "title": "No se encontró ningún miembro",
      "filtered": "Prueba otra búsqueda o borra los filtros",
      "none": "No hay miembros registrados"
    },
    "deepLink": {
      "title": "Deep Link",
      "accessLinkFor": "Enlace de acceso para <strong>{{name}}</strong>",
      "copiedToast": "¡Enlace copiado!",
      "copied": "¡Copiado!",
      "copy": "Copiar enlace",
      "importantInfo": "Información importante:",
      "valid24h": "Válido durante 24 horas",
      "singleUse": "Uso único: se invalidará tras el primer acceso",
      "autoAuth": "El miembro se autenticará automáticamente"
    }
  },
  "userEdit": {
    "backToMembers": "Volver a Miembros",
    "pendingChanges": "Cambios pendientes",
    "avatar": {
      "invalidImage": "Selecciona una imagen válida",
      "tooLarge": "La imagen debe tener como máximo 5 MB",
      "updated": "Foto actualizada — haz clic en Guardar para conservarla",
      "uploadError": "Error al subir la imagen",
      "uploading": "Subiendo…",
      "change": "Cambiar foto"
    },
    "toast": {
      "updated": "Miembro actualizado correctamente",
      "updateError": "Error al actualizar el miembro"
    },
    "validation": {
      "nameMin": "El nombre debe tener al menos 2 caracteres",
      "urlInvalid": "URL no válida",
      "phoneInvalid": "Número de teléfono no válido",
      "cpfDigits": "El CPF debe tener 11 dígitos"
    },
    "summary": {
      "memberId": "ID del miembro",
      "courses": "Cursos",
      "lessons": "Clases",
      "certificatesShort": "Certif.",
      "totalXp": "XP total",
      "createdAt": "Registrado el",
      "lastLogin": "Último inicio de sesión"
    },
    "tabs": {
      "overview": "Resumen",
      "overviewShort": "General",
      "profile": "Datos personales",
      "profileShort": "Perfil",
      "progress": "Progreso",
      "gamification": "Gamificación",
      "gamificationShort": "XP",
      "surveys": "Encuestas",
      "surveysShort": "Enc.",
      "certificates": "Certificados",
      "certificatesShort": "Cert."
    },
    "overview": {
      "personalData": "Datos personales",
      "fullName": "Nombre completo",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "cpf": "CPF",
      "birthDate": "Fecha de nacimiento",
      "permissionsAndStatus": "Permisos y estado",
      "role": "Rol",
      "status": "Estado",
      "language": "Idioma"
    },
    "groups": {
      "title": "Grupos de acceso",
      "selectedOfTotal": "<bold>{{selected}}</bold> de <bold>{{total}}</bold>",
      "pending": "Pendiente",
      "hint": "Selecciona los grupos para inscribir al miembro en todos los cursos del grupo.",
      "noActiveGroups": "Ningún grupo de acceso activo",
      "searchPlaceholder": "Buscar grupos...",
      "selectedCount_one": "{{count}} seleccionado",
      "selectedCount_zero": "{{count}} seleccionados",
      "selectedCount_other": "{{count}} seleccionados",
      "clear": "Borrar",
      "noMatch": "Ningún grupo coincide con el filtro",
      "showing": "Mostrando {{shown}} de {{total}} grupos",
      "current": "Actual"
    },
    "access": {
      "title": "Términos y acceso",
      "terms": "Términos de uso",
      "acceptance": "Aceptación",
      "accepted": "Aceptado",
      "pending": "Pendiente",
      "acceptanceDate": "Fecha de aceptación",
      "firstAccess": "Primer acceso",
      "date": "Fecha",
      "neverAccessed": "Nunca ha accedido",
      "ip": "IP",
      "location": "Ubicación",
      "userAgent": "Navegador / Dispositivo",
      "lastAccess": "Último acceso",
      "termsHistory": "Historial de aceptación de los términos",
      "version": "Versión",
      "versionValue": "v{{version}}",
      "locationFull": "Ubicación"
    },
    "surveys": {
      "emptyTitle": "Ninguna encuesta respondida",
      "emptyDescription": "Este miembro aún no ha respondido ninguna encuesta",
      "answered": "Respondidas",
      "answers": "Respuestas",
      "latest": "Última",
      "surveyFallback": "Encuesta",
      "answeredAt": "Respondida el {{date}}",
      "completed": "Completada",
      "questionFallback": "Pregunta"
    },
    "profile": {
      "notProvided": "No informado",
      "personalData": "Datos personales",
      "name": "Nombre",
      "email": "Correo electrónico",
      "phone": "Teléfono",
      "cpf": "CPF",
      "birthDate": "Fecha de nacimiento",
      "gender": "Género",
      "educationAndExperience": "Formación y experiencia",
      "occupation": "Ocupación",
      "education": "Nivel de estudios",
      "experience": "Experiencia",
      "bio": "Bio",
      "interestsAndSkills": "Intereses y habilidades",
      "interests": "Áreas de interés",
      "hobbies": "Aficiones",
      "skills": "Habilidades",
      "address": "Dirección",
      "country": "País",
      "zipCode": "Código postal",
      "state": "Estado/Provincia",
      "city": "Ciudad",
      "neighborhood": "Barrio",
      "street": "Calle",
      "number": "Número",
      "complement": "Complemento",
      "customFields": "Campos personalizados",
      "socialNetworks": "Redes sociales",
      "website": "Sitio web"
    },
    "progress": {
      "summary": "Resumen de aprendizaje",
      "enrollments": "Inscripciones",
      "lessonsStarted": "Clases iniciadas",
      "lessonsCompleted": "Clases completadas",
      "certificates": "Certificados",
      "completionRate": "Tasa de finalización",
      "enrolledCourses": "Cursos inscritos ({{count}})",
      "noEnrollments": "No hay inscripciones registradas",
      "enrolledAt": "Inscrito el {{date}}",
      "courseCompletedAt": "Completado el {{date}}",
      "recentLessons": "Últimas clases ({{count}})",
      "noActivity": "No hay actividad registrada",
      "lessonCompletedAt": "Completada el {{date}}",
      "lastUpdatedAt": "Última actualización el {{date}}"
    },
    "gamification": {
      "totalXp": "XP total",
      "level": "Nivel {{level}}",
      "achievements": "Logros",
      "available": "Disponibles",
      "completeness": "Completado",
      "achievementProgress": "Progreso de logros",
      "unlocked": "Logros desbloqueados ({{count}})",
      "noneUnlocked": "Aún no se ha desbloqueado ningún logro",
      "locked": "Por conseguir ({{count}})",
      "points": "{{points}} XP"
    }
  }
}
